import { API } from 'aws-amplify'


const advisorProfileService = {
    update,
    getOne,
    checkEmail,
    getMultiple,
    getSpecialties,
    getClientele,
    getPricing,
    getServices,
    getAssetRanges,
    getCredentials,
    getAll,
    getMeetingRequests,
    updateMeetingRequest,
    getLeads,
    create,
    marketPlaceSearch,
    universityOptions,
    getCompletenessScore,
    getFirmAdvisors
}

const myAPI = "adisorProfilesAPI"
const path = '/advisorProfile';


async function getMultiple(params) {
    return API.get(myAPI, `${path}/multiple/${params}`);
}

async function getAll() {
    return API.get(myAPI, `${path}/`);
}

async function getOne(params) {
    return API.get(myAPI, `${path}/${params}`);
}

async function checkEmail(params) {
    return API.get(myAPI, `${path}/userExists/${params}`);
}

async function getSpecialties() {
    return API.get(myAPI, `${path}/specialties`);
}

async function getClientele() {
    return API.get(myAPI, `${path}/clientele`);
}

async function getPricing() {
    return API.get(myAPI, `${path}/pricing`);
}

async function getServices() {
    return API.get(myAPI, `${path}/services`);
}

async function getAssetRanges() {
    return API.get(myAPI, `${path}/assetRanges`);
}

async function getCredentials() {
    return API.get(myAPI, `${path}/credentials`);
}

async function getMeetingRequests(id) {
    return API.get(myAPI, `${path}/meetingRequest/${id}`);
}

async function updateMeetingRequest(params, myInit) {
    return API.put(myAPI, `${path}/meetingRequest/${params}`, addCurrentUserInfo(myInit))
}

async function getLeads(id) {
    return API.get(myAPI, `${path}/leads/${id}`);
}

async function update(params, myInit, isFirmAdmin = false) {
    return API.put(myAPI, `${path}/${params}`, addCurrentUserInfo(myInit, isFirmAdmin));
}

async function create(myInit) {
    return API.post(myAPI, path, myInit);
}

async function marketPlaceSearch(myInit) {
    return API.put(myAPI, `${path}/marketplace`, myInit);
}

async function universityOptions(name) {
    return API.get(myAPI, `${path}/universityOptions?name=${name}`);
}

async function getCompletenessScore(id) {
    return API.get(myAPI, `${path}/getCompletenessScore/${id}`)
}

async function getFirmAdvisors(id, myInit) {
    return API.put(myAPI, `${path}/firmAdmin/${id}`, addCurrentUserInfo(myInit, true))
}

function addCurrentUserInfo(myInit, isFirmAdmin = false) {
    const user = JSON.parse(localStorage.getItem('user'))
    myInit.body.currentUserId = isFirmAdmin ? user.firmID : JSON.parse(localStorage.getItem('user')).id;
    myInit.body.userGroups = user.groups;
    myInit.body.firmID = isFirmAdmin ? user.firmID : undefined;
    return myInit;
}



export default advisorProfileService;